<template>
	<div v-if="isVisible" class="product-click-regions" @keyup.enter.stop="onClick" @keydown.space.prevent="onClick">
		<product-region
				v-for="(region, i) in regions"
				:key="`${i}_${sku}-${region.height}-${region.width}-${region.top}-${region.left}`"
				:aria-label="i === largestRegionIndex ? product.contents : null"
				:is-in-viewport="isInViewport"
				:is-visible="isVisible"
				:product="product"
				:region="region"
				:style="getRegionStyle(region, pStyle)"
				:tabindex="i === largestRegionIndex ? 0 : -1"
				class="product-click-region"
				@click="onClick"
		/>
		<!--div
		  v-for="(region, i) in regions"
		  :key="`${i}_${sku}-${region.height}-${region.width}-${region.top}-${region.left}`"
		  :aria-label="region.contents"
		  :class="{hide:hidePlayBtn && isVideo}"
		  :style="getRegionStyle(region, pStyle)"
		  class="product-click-region"
		  @click.stop="onClick"
		  @keyup.enter.stop="onClick"
		>
		  <product-region :product="product" :region="region" />
		  <play-button v-if="isVideo" :product="product" :region="region" />
		</div -->
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
//import PlayButton from "@/components/buttons/PlayButton.vue";
import PdpProductMixin from "@/features/pdp/PdpProductMixin";
import {PRODUCT_REGION_CLICK, PRODUCT_REGION_CLICK_EXTERNAL_LINK, PRODUCT_REGION_CLICK_IN_BLOCK_VIDEO, PRODUCT_REGION_CLICK_VALID, PRODUCT_REGION_CLICK_VIDEO} from "@/components/block/BlockEvents";
//import AppConfig from "@/classes/AppConfig";

import Lytics from "@/classes/Lytics";
import ProductRegion from "@/components/block/elements/ProductRegion.vue";


export default {
	name: "ProductClickRegions",
	mixins: [blockElementMixin, PdpProductMixin],
	components: {ProductRegion},
	props: {
		product: {
			type: Object,
			default: () => {
				return {};
			}
		},
		hidePlayBtn: {
			type: Boolean
		},
		blockId: {
			type: String
		},
		isAd: {
			type: Boolean
		},
		banners: {
			type: Object
		},
		page: {
			type: Object
		}
	},
	computed: {
		...mapState(["currentPageNumber"]),
		...mapGetters("config", ["settings", "branding", "features"]),
		...mapGetters("landingPage", ["currentFlyer"]),
		...mapGetters(["storeId", "language", "isCTC"]),
		...mapGetters("events", ["events"]),
		...mapState("shoppingList", ["shoppingList"]),
		...mapGetters(["productsBySKU"]),
		...mapGetters(['highlightResults']),
		...mapGetters('search', ['showSearchResults']),
		regions() {
			return this.product.clickRegions;
		},
		sku() {
			return (this.product.sku || "").toUpperCase().replace(`${this.actionType.toUpperCase()}|`, '').split('|')?.[0].trim().toLowerCase();
			/*if ((this.product.sku || "")?.toLowerCase().includes("inblock"))
			  return this.product.sku.split("|")[0].toLowerCase();
			else
			  return (this.product.sku || "")?.toLowerCase().trim();*/
		},
		actionType() {
			return (this.product.actionType || this.product.sku || '').trim().toLowerCase();
			//return (this.product.actionType || "")?.toLowerCase().trim();
		},
		isValidProduct() {
			const invalidSkus = ["url", "playtc", "play", "inblock", "animatesku", "inlink"];
			return !!this.productsBySKU[this.sku] && !invalidSkus.includes(this.sku.toLowerCase());
		},
		isVideo() {
			const actionType = (this.actionType || this.sku).toLowerCase();
			return actionType.includes("inblock") || actionType.includes("animate") || actionType.includes("play");
		},

		checkProductInSL() {
			return this.shoppingList.some((listItem) => listItem.sku == this.sku);
		},
		isCarousel() {
			return (this.blockData?.carouselBlocks?.length ?? 0 >= 1) || (this.blockData.slideNumber !== undefined);
		},
		isCTCGrandOpening() {
			// Disable PDPs for CTC in Grand Opening flyer blocks || Allow ad pages to be clicked.
			return this.currentFlyer?.flyerCategory === "Grand Opening" && this.isCTC && this.actionType !== "url" && this.sku !== "url";
		},
		imageSrc() {
			return (this.actionType === "play" && this.product.url);
		},
		isWithinInBlockVideo() {
			return this.blockData.products.some((prod) => {
				const isVideo = prod.actionType || prod.sku;
				return ((isVideo)?.toLowerCase().includes("inblock") || (isVideo)?.toLowerCase().includes("animate"));
			});
		},
		pStyle() {
			if (this.isVideo) return "absolute";
			if (this.currentFlyer?.disableClickRegions) return "relative";
			if (this.product?.disableClickRegions) return "relative";
			return "absolute";
		},
		searchIsVisible() {
			return !this.highlightResults && this.showSearchResults
		},
		largestRegionIndex() {
			if (!this.regions.length) return -1;
			let maxArea = -1;
			let index = -1;
			this.regions.forEach((region, i) => {
				const area = region.height * region.width;
				if (area > maxArea) {
					maxArea = area;
					index = i;
				}
			})
			return index;
		}
	},
	methods: {
		...mapActions(["setCurrentVideo"]),
		...mapActions("events", ["triggerEvent"]),
		onClick(region) {

			console.log("onClick", this.product, "  Region:", region);

			console.log(`isValidProduct ${region.sku}: `, this.isValidProduct);

			if (this.isValidProduct) {
				console.log("Valid Product Clicked! SKU:", this.sku);
				this.triggerEvent({"event": PRODUCT_REGION_CLICK_VALID, data: this});
			}
			const contentSource = this.product.contentSource || this.product.url;
			const externalURL = this.features.pdp["enableExternalURL"] || false;
			const isUrlType = (this.actionType === "url" || this.sku === "url");
			const isInlink = (this.actionType || this.sku).includes("inlink");
			const client = this.features.pdp.client;
			// -----------------------------------------------------------
			// ADS
			// -----------------------------------------------------------
			if (this.isAd) {
				this.triggerEvent({"event": "productRegionsWithSku", data: this});
				window.open(this.banners.linkUrlEn);
				return;
			}
			// -----------------------------------------------------------
			// 	VIDEOS
			// -----------------------------------------------------------
			if (this.isVideo) {
				switch (this.actionType || this.sku) {
					case "inblock":
					case "inblocksku":
					case "animate":
					case "animatesku":
						this.triggerEvent({"event": PRODUCT_REGION_CLICK_IN_BLOCK_VIDEO, data: this});
						this.$emit("onRegionClick", this, "inblock");
						break;
					case "play":
						this.triggerEvent({"event": PRODUCT_REGION_CLICK_VIDEO, data: this});
						this.setCurrentVideo(`${contentSource}`);
						break;
					default:
						this.triggerEvent({"event": PRODUCT_REGION_CLICK_VIDEO, data: this});
						this.setCurrentVideo(`${contentSource}`);
				}
				return;
			}
			// -----------------------------------------------------------
			// 	 INLINK (scroll to doc/sku)
			// -----------------------------------------------------------
			if (isInlink) {
				const docName = contentSource.match(/doc=(.+)/i)?.[1] ?? null;
				const sku = contentSource.match(/sku=(\d+)/i)?.[1] ?? null;

				if (docName) this.$root.$emit("trigger-scroll-to-doc", docName);
				if (sku) this.$root.$emit("trigger-scroll-to-sku", sku);
				return;
			}
			// -----------------------------------------------------------
			// 		 EXTERNAL URL (Feature flag)
			// -----------------------------------------------------------
			if (externalURL && !isUrlType) {
				this.product.url = this.isProductURL
					? (client === "londondrugs" || client === "Sportchek"
						? this.productURLLDF
						: this.productURL)
					: "";
				this.triggerEvent({"event": PRODUCT_REGION_CLICK_EXTERNAL_LINK, data: this});
				Lytics.TriggerSelectItem({
					item_list_name: this.searchIsVisible ? "search" : "flyer",
					page_number: this.page.page_num || this.currentPageNumber,
					name: this.product.productEn || this.product.productFr,
					name_en: this.product.productEn,
					name_fr: this.product.productFr,
					product_id: this.product.sku,
					price: this.product.regularPrice,
					sale_price: this.product.salePrice,
					category: this.product.mainCategoryEn || this.product.mainCategoryFr,
					category_2: this.product.subCategoryEn || this.product.subCategoryFr,
					image_url: this.product.productImage
				});
				return;
			}
			// -----------------------------------------------------------
			//    URL TYPE (actionType === "url" or sku = "url")
			// -----------------------------------------------------------
			if (isUrlType) {
				this.triggerEvent({event: PRODUCT_REGION_CLICK_EXTERNAL_LINK, data: this});
				return;
			}
			// -----------------------------------------------------------
			// 	 NORMAL PRODUCT CLICK
			// -----------------------------------------------------------
			this.triggerEvent({event: PRODUCT_REGION_CLICK, data: this});
			let item_list_name = this.searchIsVisible ? "search" : this.isWithinInBlockVideo ? "in_block_video_click" : "flyer";
			Lytics.TriggerSelectItem({
				item_list_name,
				page_number: this.page.page_num || this.currentPageNumber,
				name: this.product.productEn || this.product.productFr,
				name_en: this.product.productEn,
				name_fr: this.product.productFr,
				product_id: this.product.sku,
				price: this.product.regularPrice,
				sale_price: this.product.salePrice,
				category: this.product.mainCategoryEn || this.product.mainCategoryFr,
				category_2: this.product.subCategoryEn || this.product.subCategoryFr,
				image_url: this.product.productImage
			});
			// -----------------------------------------------------------
			// 	 CAROUSEL EVENT
			// -----------------------------------------------------------
			if (this.isCarousel) {
				Lytics.TriggerCarouselClick({
					page_number: this.page.page_num || this.currentPageNumber,
					name: this.product.productEn || this.product.productFr,
					name_en: this.product.productEn,
					name_fr: this.product.productFr,
					product_id: this.product.sku,
					price: this.product.regularPrice,
					sale_price: this.product.salePrice,
					category: this.product.mainCategoryEn || this.product.mainCategoryFr,
					category_2: this.product.subCategoryEn || this.product.subCategoryFr,
					image_url: this.product.productImage,
				}, this.searchIsVisible);
			}
			this.$emit("onRegionClick", this, "productRegion");

			/*if(this.settings.events?.productRegionClick) {
					AppConfig.ParseEvent(this.settings.events?.productRegionClick, {__self: this});
				  }*/
		},
		getRegionStyle(r, s) {
			return {
				left: `${r.left}%`,
				top: `${r.top}%`,
				width: `${r.width}%`,
				height: `${r.height}%`,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				position: s
			};
		},

	}
};
</script>

<style lang="scss">
.product-click-regions {
  cursor: pointer;

  .hide {
	display: none !important;
  }

  &:hover, &:focus {
	.product-click-region {
	  animation: flash 1s;
	  border-radius: 5%;

	}

	@keyframes flash {
	  0% {
		background: rgba(255, 255, 255, 0.2);
	  }
	  100% {
		background: rgba(0, 0, 0, 0)
	  }
	}
  }

  .product-click-region {
	position: absolute;
	outline: none;
  }

  .front {
	width: 90%;
	height: auto;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;

	z-index: 9999;
	background: transparent;
	border-radius: 50%;
	box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
	margin: 0;
	transform: scale(1);
	animation: pulse-red 2s infinite;
  }

  @keyframes pulse-red {
	0% {
	  transform: scale(0.95);
	  box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.9);
	}

	70% {
	  transform: scale(1);
	  box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
	}

	100% {
	  transform: scale(0.95);
	  box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
	}
  }
}

.overrideStyles.product-click-regions {
  div.product-click-region {
	position: absolute;
	top: 0 !important;
	left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	z-index: 99 !important;
  }
}
</style>
